import { Injectable } from '@angular/core';
import {HttpService} from "../http.service";
import {environment} from "@shared-environments/environment";

@Injectable()
export class WhiteLabelService {


    constructor(private networkHelper: HttpService) { }

    private getByIdUrl = '/white-label/:id';
    private updateUrl = '/white-label/:id';
    private getAllSettingsByIdUrl = '/white-label/all-settings/:id';
    private getSettingsByDomainNameUrl = '/white-label/settings-domain/:domain';
    private myListUrl = '/me/get-white-label-info'
    private listUrl = '/white-label/list'
    private getAccountsUrl = '/white-label/get-accounts/:id'
    private copyUrl = '/white-label/copy/:id'
    private cancelAccountInvitationUrl = '/white-label/account-invitation/:id/:whiteLabelId'
    private useWhiteLabelDesignUrl = '/white-label/use-design/:id/'
    private getPublisherByWhiteLabelUrl = '/white-label/get-publisher/:id/'
    private checkDomainUrl = '/white-label/check-domain/:domain'


    getAllSettingsById(id: string){
        return this.networkHelper.get<any>(environment.apiURL + this.getAllSettingsByIdUrl.replace(':id', id));
    }

    getSettingsByDomainName(domain: string){
        return this.networkHelper.getWithSSR<any>(environment.apiURL + this.getSettingsByDomainNameUrl.replace(':domain', domain));
    }

    getById(id: string){
        return this.networkHelper.getWithSSR<any>(environment.apiURL + this.getByIdUrl.replace(':id', id));
    }

    list(pagination:any, filter:any){
        return this.networkHelper.get<any>(environment.apiURL + this.listUrl,{...pagination, ...filter});
    }
    myList(query: any){
        return this.networkHelper.get<any>(environment.apiURL + this.myListUrl);
    }
    update(id: string, data: any){
        return this.networkHelper.put<any>(environment.apiURL + this.updateUrl.replace(':id', id), data);
    }

    getAccounts(whiteLabelId: string){
        return this.networkHelper.get<any>(environment.apiURL + this.getAccountsUrl.replace(':id', whiteLabelId));
    }
    cancelAccountInvitation(id: string, whiteLabelId: string){
        return this.networkHelper.del<any>(environment.apiURL + this.cancelAccountInvitationUrl.replace(":id", id).replace(':whiteLabelId', whiteLabelId));
    }

    copy(id: string, data: any){
        return this.networkHelper.post<any>(environment.apiURL + this.copyUrl.replace(":id", id), data);
    }

    useWhiteLabelDesign(id: string){
        return this.networkHelper.post<any>(environment.apiURL + this.useWhiteLabelDesignUrl.replace(":id", id), {});
    }

    getPublisherByWhiteLabel(id: string){
        return this.networkHelper.get<any>(environment.apiURL + this.getPublisherByWhiteLabelUrl.replace(":id", id), {});
    }

    checkDomain(domain: string) {
        return this.networkHelper.get<any>(environment.apiURL + this.checkDomainUrl.replace(':domain', domain))
    }
}
